import { Label, ShowInput, Title, StyledAddArea, TextArea, FileInputWrapper, Span, ButtonContainer, StyledSelect, SmallText, StyledButtonSalvar, StyledButtonVoltar, LeftColumn, RightColumn, Row, HiddenFileInput, FileInputButton, MainContainer, FormContainer, ProfileContainerInfo, ArquivoAtual, ArquivoEscolhido } from "./styles";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { appStatus } from "../../store/modules/app_status/actions";
import { useHookFormMask } from "use-mask-input";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ErrorForm } from "../../components/inter_register_user/ErrorForm";
import { registerProjectSchema } from "../../components/project_register_info/registerProjectValidation";
import WarningDeleteModal from '../../components/warning_delete_modal';
import { projectService } from "../../services/projectService";
import { userService } from "../../services/userService";
import { CardCheckbox } from "../../components/project_register_info/CheckBox/CheckBox";
import { sdgToCardValueMap } from "../../components/project_register_info/CheckBox/CheckBox";
import CreateArea from "../../components/guardian/CreateArea";
import { guardianAreaService } from "../../services/guardianAreaService";

function normalizeUsersPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.users)) return payload.users;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

const EditProject = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [project, setProject] = useState(null);
  const [isCpf, setIsCpf] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [selectedCards, setSelectedCards] = useState([]);
  const [isLoadingSdgs, setIsLoadingSdgs] = useState(false);
  const [areas, setAreas] = useState([]);
  const [areaCounter, setAreaCounter] = useState(1);
  const [emailCheckInProgress, setEmailCheckInProgress] = useState(false);
  const [existingUserData, setExistingUserData] = useState(null);
  const [originalOwnerData, setOriginalOwnerData] = useState(null);
  const [emailChecked, setEmailChecked] = useState(true); // Começa como true porque já temos um email válido
  const lastCheckedEmailRef = useRef("");
  const [propUsers, setPropUsers] = useState([]);

  const fetchProjectSdgs = async (projectId) => {
    try {
      setIsLoadingSdgs(true);
      const token = sessionStorage.getItem("access_token");
      const response = await projectService.getAllSdgsByProject(projectId, token);

      const sdgValues = Object.entries(response.sdgs || {})
        .filter(([_, data]) => data.value === true)
        .map(([key]) => sdgToCardValueMap[key])
        .filter(Boolean);

      setSelectedCards(sdgValues);
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Atenção!",
        text: "Não foi possível carregar as ODS associadas ao projeto.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoadingSdgs(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: zodResolver(registerProjectSchema),
    defaultValues: {
      project_owner: {
        name: "",
        phone: "",
        email: "",
        cpf: "",
        cnpj: "",
        person_type: "Física",
      }
    }
  });

  useEffect(() => {
    if (existingUserData) {

      setTimeout(() => {
        setValue("project_owner.name", existingUserData.full_name || existingUserData.name || "", { shouldValidate: true });
        setValue("project_owner.email", existingUserData.email || "", { shouldValidate: true });
        setValue("project_owner.phone", existingUserData.phone || "", { shouldValidate: true });
        setValue("project_owner.cpf", existingUserData.cpf || "", { shouldValidate: true });
        setValue("project_owner.cnpj", existingUserData.cnpj || "", { shouldValidate: true });

        if (existingUserData.cnpj) {
          setValue("project_owner.person_type", "Jurídica", { shouldValidate: true });
          setIsCpf(false);
        } else if (existingUserData.cpf) {
          setValue("project_owner.person_type", "Física", { shouldValidate: true });
          setIsCpf(true);
        }
      }, 100);
    }
  }, [existingUserData, setValue]);

  const ownerEmail = watch("project_owner.email");

  useEffect(() => {
    const fetchPropUsers = async () => {
      try {
        const usersRes = await userService.getUsers();
        const allUsers = normalizeUsersPayload(usersRes);
        const props = allUsers
          .filter((user) => user?.user_type === "PROP" && user?.email)
          .slice()
          .sort((a, b) => {
            const nameA = (a.full_name || a.name || a.email || "").toLowerCase();
            const nameB = (b.full_name || b.name || b.email || "").toLowerCase();
            return nameA.localeCompare(nameB, "pt-BR");
          });
        setPropUsers(props);
      } catch (error) {
        console.error("Erro ao buscar usuários PROP:", error);
      }
    };

    fetchPropUsers();
  }, []);

  const ownerEmailOptions = (() => {
    const list = [...propUsers];
    const currentEmail = (ownerEmail || originalOwnerData?.email || "").trim();
    if (
      currentEmail &&
      !list.some(
        (user) =>
          (user.email || "").toLowerCase() === currentEmail.toLowerCase()
      )
    ) {
      list.unshift({
        id: `current-owner-${currentEmail}`,
        email: currentEmail,
        full_name: originalOwnerData?.name || "Proprietário atual",
        phone: originalOwnerData?.phone,
        cpf: originalOwnerData?.cpf,
        cnpj: originalOwnerData?.cnpj,
        user_type: "PROP",
      });
    }
    return list;
  })();

  const applyPropOwner = (email) => {
    const selected = ownerEmailOptions.find(
      (user) => (user.email || "").toLowerCase() === (email || "").toLowerCase()
    );

    if (!selected) {
      setExistingUserData(null);
      setEmailChecked(false);
      return;
    }

    // Mesmo e-mail do dono original: não trata como troca de usuário
    if (
      originalOwnerData?.email &&
      selected.email?.toLowerCase() === originalOwnerData.email.toLowerCase()
    ) {
      setExistingUserData(null);
      setValue("project_owner.name", originalOwnerData.name || "");
      setValue("project_owner.phone", originalOwnerData.phone || "");
      setValue("project_owner.cpf", originalOwnerData.cpf || "");
      setValue("project_owner.cnpj", originalOwnerData.cnpj || "");
      if (originalOwnerData.cnpj) {
        setValue("project_owner.person_type", "Jurídica");
        setIsCpf(false);
      } else {
        setValue("project_owner.person_type", "Física");
        setIsCpf(true);
      }
      lastCheckedEmailRef.current = selected.email;
      setEmailChecked(true);
      return;
    }

    setExistingUserData(selected);
    setValue("project_owner.name", selected.full_name || selected.name || "");
    setValue("project_owner.phone", selected.phone || "");
    setValue("project_owner.cpf", selected.cpf || "");
    setValue("project_owner.cnpj", selected.cnpj || "");

    if (selected.cnpj) {
      setValue("project_owner.person_type", "Jurídica");
      setIsCpf(false);
    } else {
      setValue("project_owner.person_type", "Física");
      setIsCpf(true);
    }

    lastCheckedEmailRef.current = selected.email;
    setEmailChecked(true);
  };

  useEffect(() => {
    if (ownerEmail &&
      ownerEmail.includes("@") &&
      ownerEmail !== lastCheckedEmailRef.current &&
      !emailCheckInProgress &&
      ownerEmail !== originalOwnerData?.email &&
      !existingUserData) { // Adicionei esta condição

      const timer = setTimeout(() => {
        checkEmailExists(ownerEmail);
      }, 1000); // Esperar 1 segundo após parar de digitar

      return () => clearTimeout(timer);
    }
  }, [ownerEmail, emailCheckInProgress, originalOwnerData, existingUserData]);

  const personType = watch("project_owner.person_type");

  useEffect(() => {
    setIsCpf(personType === "Física");
  }, [personType]);

  const fetchProjectAreas = async (projectId) => {
    try {
      const areasRes = await projectService.getProjectAreas(projectId);
      const areasData = areasRes.map((area, index) => {
        const areaId = area.id_code || area.id;

        if (!areaId) {
          console.error('❌ Área sem ID:', area);
        }

        return {
          id: areaId,
          number: area.area_number || index + 1,
          name: area.name || `Área ${index + 1}`,
          saved: true,
          isFromDatabase: true,
          data: {
            id: areaId,
            id_code: area.id_code,
            area_number: area.area_number || index + 1,
            name: area.name || `Área ${index + 1}`,
            vert_responsible: area.vert_responsible || "",
            adi_responsible: area.adi_responsible || "",
            total_area: area.total_area || "",
            legal_reserve_area: area.legal_reserve_area || "",
            matricula_status: area.matricula_status || "",
            reserve_legal_status: area.reserve_legal_status || "",
            georeferencing_status: area.georeferencing_status || "",
            sicar_code: area.sicar_code || "",
            status_car: area.status_car || "",
            other_responsibles: area.other_responsibles || [],
            adi_image: area.adi_image || null,
            project: projectId
          }
        };
      });

      setAreas(areasData);

      if (areasData.length > 0) {
        const maxAreaNumber = Math.max(...areasData.map(area => area.number));
        setAreaCounter(maxAreaNumber + 1);
      }
    } catch (error) {
      console.error('Erro ao buscar áreas do projeto:', error);
      Swal.fire({
        title: "Atenção!",
        text: "Não foi possível carregar as áreas do projeto.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    const state = location.state;
    if (state?.project) {
      const projectData = state.project;

      const ownerDetails = projectData.owner_details;

      let personTypeValue = projectData.physical_or_legal_entity || "";

      const hasCpf = ownerDetails?.cpf;
      const hasCnpj = ownerDetails?.cnpj;

      if (!personTypeValue) {
        if (hasCpf && !hasCnpj) {
          personTypeValue = "Física";
        } else if (hasCnpj && !hasCpf) {
          personTypeValue = "Jurídica";
        } else {
          personTypeValue = "Física";
        }
      }

      setProject(projectData);

      // Salvar dados originais
      const originalData = {
        email: ownerDetails?.email || "",
        name: ownerDetails?.full_name || "",
        phone: ownerDetails?.phone || "",
        cpf: ownerDetails?.cpf || "",
        cnpj: ownerDetails?.cnpj || "",
        person_type: personTypeValue,
      };

      setOriginalOwnerData(originalData);
      lastCheckedEmailRef.current = originalData.email;

      fetchProjectSdgs(projectData.id);
      fetchProjectAreas(projectData.id);

      reset({
        project_owner: originalData,
        title: projectData.title,
        address: projectData.address,
        total_area: String(projectData.total_area || ""),
        legal_reserve_area: String(projectData.legal_reserve_area || ""),
        status_car: projectData.status_car || "",
        sicar_code: projectData.sicar_code || "",
        matricula_status: projectData.matricula_status || "",
        georeferencing_status: projectData.georeferencing_status || "",
        reserve_legal_status: projectData.reserve_legal_status || "",
        conservation_unit: projectData.conservation_unit || "",
        owner_actions_to_preserve_forest: projectData.owner_actions_to_preserve_forest || "",
        legal_reserve_deficit: String(projectData.legal_reserve_deficit || ""),
        has_federal_debt: String(projectData.has_federal_debt || ""),
      });

      setIsCpf(personTypeValue === "Física");
      setEmailChecked(true);
      setExistingUserData(null);
    }
  }, [location.state, reset]);

  const checkEmailExists = async (email) => {
    if (!email || email.length < 5 || !email.includes("@")) {
      return;
    }

    setEmailCheckInProgress(true);

    try {
      const response = await userService.checkEmailExists(email);

      if (response.exists) {
        // Verificar se é o mesmo usuário (comparar IDs)
        const isSameUser = response.user.id === project?.owner;

        if (!isSameUser) {
          // Se o email existe para outro usuário, perguntar ao usuário
          const result = await Swal.fire({
            title: "Email já cadastrado",
            text: `Já existe outro usuário com o email "${email}". Deseja usar as informações deste usuário como proprietário?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, usar estas informações",
            cancelButtonText: "Não, manter os dados atuais",
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            backdrop: 'var(--surface-overlay)'
          });

          if (result.isConfirmed) {

            setExistingUserData(response.user);

            let personTypeValue = "Física";
            if (response.user.cnpj) {
              personTypeValue = "Jurídica";
            }

            setValue("project_owner.person_type", personTypeValue, { shouldValidate: true, shouldDirty: true });

            setIsCpf(personTypeValue === "Física");

            setTimeout(() => {
              // Agora preencher os outros campos
              setValue("project_owner.name", response.user.full_name || response.user.name || "", { shouldValidate: true, shouldDirty: true });
              setValue("project_owner.email", response.user.email || "", { shouldValidate: true, shouldDirty: true });
              setValue("project_owner.phone", response.user.phone || "", { shouldValidate: true, shouldDirty: true });

              // Preencher CPF ou CNPJ baseado no tipo
              if (personTypeValue === "Física" && response.user.cpf) {
                setValue("project_owner.cpf", response.user.cpf, { shouldValidate: true, shouldDirty: true });
                setValue("project_owner.cnpj", "", { shouldValidate: true, shouldDirty: true });
              } else if (personTypeValue === "Jurídica" && response.user.cnpj) {
                setValue("project_owner.cnpj", response.user.cnpj, { shouldValidate: true, shouldDirty: true });
                setValue("project_owner.cpf", "", { shouldValidate: true, shouldDirty: true });
              }
            }, 50);

            lastCheckedEmailRef.current = response.user.email;
            setEmailChecked(true);

            // DEBUG: Verificar valores após set com delay maior
            setTimeout(() => {

              const personTypeSelect = document.getElementById("person_type");
              if (personTypeSelect) {
                personTypeSelect.value = personTypeValue;
              }
            }, 200);

            Swal.fire({
              title: "Informações carregadas",
              text: "Os dados do novo proprietário foram carregados. Você pode editá-los se necessário.",
              icon: "info",
              confirmButtonText: "OK",
              timer: 2000
            });
          } else {
            setValue("project_owner.email", originalOwnerData?.email || "");
            setEmailChecked(true);
            setExistingUserData(null);
            lastCheckedEmailRef.current = originalOwnerData?.email || "";
          }
        } else {
          setEmailChecked(true);
          setExistingUserData(null);
          lastCheckedEmailRef.current = email;
        }
      } else {
        setEmailChecked(true);
        setExistingUserData(null);
        lastCheckedEmailRef.current = email;
      }
    } catch (error) {
      console.error("Erro ao verificar email:", error);
      // Em caso de erro, continuar sem verificação
      setEmailChecked(true);
      setExistingUserData(null);
    } finally {
      setEmailCheckInProgress(false);
    }
  };

  const handleEntityChange = (e) => {
    const value = e.target.value;
    setIsCpf(value === "Física");
  };

  const handleCardSelection = (newSelection) => {
    setSelectedCards(newSelection);
  };

  const registerWithMask = useHookFormMask(register);

  const handleAddArea = () => {
    const newAreaId = Date.now();
    const newAreaNumber = areaCounter;

    const newArea = {
      id: newAreaId,
      number: newAreaNumber,
      saved: false,
      isFromDatabase: false,
      data: {
        id: newAreaId,
        area_number: newAreaNumber,
        name: `Área ${newAreaNumber}`,
        vert_responsible: "",
        adi_responsible: "",
        total_area: "",
        legal_reserve_area: "",
        matricula_status: "",
        reserve_legal_status: "",
        georeferencing_status: "",
        sicar_code: "",
        status_car: "",
        other_responsibles: [],
        adi_image: null
      }
    };

    setAreas(prev => [...prev, newArea]);
    setAreaCounter(prev => prev + 1);
  };

  const handleAreaSave = async (areaId, areaData) => {
    try {
      const areaInState = areas.find(area => area.id === areaId);

      if (!areaInState) {
        console.error('❌ Área não encontrada no estado:', areaId);
        throw new Error("Área não encontrada no estado.");
      }

      const isExistingArea = areaInState.isFromDatabase;

      if (!isExistingArea) {
        const result = await handleCreateArea(areaData);
        setAreas(prev => prev.map(area => {
          if (area.id === areaId) {
            return {
              ...area,
              id: result.id || result.id_code || areaId,
              data: {
                ...areaData,
                id: result.id || result.id_code,
                id_code: result.id_code || result.id
              },
              saved: true,
              isFromDatabase: true
            };
          }
          return area;
        }));
        return;
      }

      if (isExistingArea && areaData.id_code) {
        const edit_reason = `Atualização via edição do projeto${project?.title ? ` "${project.title}"` : ""}`;

        const formatBrazilianNumber = (value) => {
          if (!value || value === '') return '';
          if (typeof value === 'number') return String(value);
          return String(value).replace(/\./g, '').replace(',', '.');
        };

        const dataToSend = { ...areaData };

        if (dataToSend.total_area) {
          dataToSend.total_area = formatBrazilianNumber(dataToSend.total_area);
        }
        if (dataToSend.legal_reserve_area) {
          dataToSend.legal_reserve_area = formatBrazilianNumber(dataToSend.legal_reserve_area);
        }
        if (dataToSend.vert_responsible) {
          dataToSend.vert_responsible = parseInt(dataToSend.vert_responsible, 10);
        }
        if (dataToSend.adi_responsible) {
          dataToSend.adi_responsible = parseInt(dataToSend.adi_responsible, 10);
        }

        delete dataToSend.id;
        delete dataToSend.id_code;

        await guardianAreaService.updateGuardianArea(
          areaData.id_code,
          dataToSend,
          edit_reason
        );
      }

      setAreas(prev => prev.map(area => {
        if (area.id === areaId) {
          return {
            ...area,
            data: {
              ...areaData,
              id: areaData.id || areaId,
              id_code: areaData.id_code || area.data.id_code
            },
            saved: true
          };
        }
        return area;
      }));

    } catch (error) {
      console.error('❌ Erro ao salvar área:', error);
      Swal.fire({
        title: "Erro!",
        text: "Não foi possível salvar a área.",
        icon: "error",
        confirmButtonText: "OK",
      });
      throw error;
    }
  };

  const handleCreateArea = async (areaData) => {
    try {

      const formatBrazilianNumber = (value) => {
        if (!value || value === '') return '';

        if (typeof value === 'number') return String(value);

        const cleaned = String(value)
          .replace(/\./g, '')
          .replace(',', '.');

        return cleaned;
      };

      const dataToSend = {
        ...areaData,
        area_number: areaData.areaNumber,
        project: areaData.project ?? project?.id,
      };

      delete dataToSend.id;
      delete dataToSend.id_code;
      delete dataToSend.areaNumber;

      if (dataToSend.total_area) {
        dataToSend.total_area = formatBrazilianNumber(dataToSend.total_area);
      }
      if (dataToSend.legal_reserve_area) {
        dataToSend.legal_reserve_area = formatBrazilianNumber(dataToSend.legal_reserve_area);
      }
      if (dataToSend.vert_responsible) {
        dataToSend.vert_responsible = parseInt(dataToSend.vert_responsible, 10);
      }
      if (dataToSend.adi_responsible) {
        dataToSend.adi_responsible = parseInt(dataToSend.adi_responsible, 10);
      }
      if (dataToSend.other_responsibles && Array.isArray(dataToSend.other_responsibles)) {
        dataToSend.other_responsibles = dataToSend.other_responsibles.map(id =>
          parseInt(id, 10)
        );
      }

      const result = await guardianAreaService.createGuardianArea(dataToSend);

      return {
        id: result.id_code || result.id,
        id_code: result.id_code
      };

    } catch (error) {
      console.error('❌ Erro detalhado ao criar nova área:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers
      });

      Swal.fire({
        title: "Erro!",
        text: `Não foi possível criar a nova área. Detalhes: ${error.response?.data?.detail || error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
      throw error;
    }
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    try {
      if (ownerEmail && !emailChecked && !emailCheckInProgress) {
        Swal.fire({
          title: "Verificar email",
          text: "Por favor, termine de digitar o email e aguarde a verificação automática, ou clique fora do campo para verificar.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        setIsSubmitting(false);
        return;
      }

      const usuarioId = sessionStorage.getItem("usuario_id");
      const formData = new FormData();
      const newAreas = areas.filter(area => !area.isFromDatabase && area.saved);

      for (const area of newAreas) {
        try {
          const result = await handleCreateArea(area.data);

          setAreas(prev => prev.map(a =>
            a.id === area.id
              ? {
                ...a,
                id: result.id,
                data: {
                  ...a.data,
                  id: result.id,
                  id_code: result.id_code
                },
                isFromDatabase: true
              }
              : a
          ));

        } catch (error) {
          console.error(`❌ Falha ao criar área ${area.number}:`, error);
          throw new Error(`Falha ao criar área ${area.number}`);
        }
      }

      await new Promise(resolve => setTimeout(resolve, 100));

      // ADICIONAR DADOS DO PROPRIETÁRIO
      if (data.project_owner) {
        const ownerData = {
          name: data.project_owner.name,
          email: data.project_owner.email,
          phone: data.project_owner.phone,
          cpf: data.project_owner.cpf,
          cnpj: data.project_owner.cnpj,
          person_type: data.project_owner.person_type
        };

        formData.append('owner_data', JSON.stringify(ownerData));
        formData.append('physical_or_legal_entity', data.project_owner.person_type);
      }


      Object.entries(selectedFiles).forEach(([key, file]) => {
        if (file) formData.append(key, file);
      });

      const appendFormData = (formData, dataToAppend, parentKey = "") => {
        Object.entries(dataToAppend).forEach(([key, value]) => {
          const formKey = parentKey ? `${parentKey}[${key}]` : key;

          // Pular project_owner pois já enviamos como owner_data
          if (key === 'project_owner') {
            return;
          }

          if (value && typeof value === "object" && !(value instanceof File)) {
            appendFormData(formData, value, formKey);
          } else {
            formData.append(formKey, value ?? "");
          }
        });
      };

      appendFormData(formData, data);

      const odsData = {};
      Object.entries(cardValueToSdgKey).forEach(([cardValue, sdgKey]) => {
        odsData[sdgKey] = selectedCards.includes(cardValue);
      });
      formData.append("ods_data", JSON.stringify(odsData));
      formData.append("usuario_id", usuarioId);

      const currentAreas = areas.filter(area => area.saved);

      currentAreas.forEach((area, index) => {
        const areaData = area.data;

        const areaIdToSend = areaData.id_code || areaData.id;
        if (areaIdToSend) {
          formData.append(`areas[${index}][id]`, areaIdToSend);
        }

        formData.append(`areas[${index}][name]`, areaData.name || `Área ${areaData.area_number || area.number}`);
        formData.append(`areas[${index}][area_number]`, areaData.area_number || area.number);
        formData.append(`areas[${index}][vert_responsible]`, areaData.vert_responsible || "");
        formData.append(`areas[${index}][adi_responsible]`, areaData.adi_responsible || "");
        formData.append(`areas[${index}][total_area]`, areaData.total_area || "");
        formData.append(`areas[${index}][legal_reserve_area]`, areaData.legal_reserve_area || "");
        formData.append(`areas[${index}][matricula_status]`, areaData.matricula_status || "");
        formData.append(`areas[${index}][reserve_legal_status]`, areaData.reserve_legal_status || "");
        formData.append(`areas[${index}][georeferencing_status]`, areaData.georeferencing_status || "");
        formData.append(`areas[${index}][sicar_code]`, areaData.sicar_code || "");
        formData.append(`areas[${index}][status_car]`, areaData.status_car || "");

        if (areaData.other_responsibles && areaData.other_responsibles.length > 0) {
          areaData.other_responsibles.forEach((responsible, respIndex) => {
            formData.append(`areas[${index}][other_responsibles][${respIndex}]`, responsible);
          });
        }

        if (areaData.adi_image && areaData.adi_image instanceof File) {
          formData.append(`areas[${index}][adi_image]`, areaData.adi_image);
        }
      });

      await projectService.updateProject(project.id, formData);

      await Swal.fire({
        title: "Sucesso!",
        text: "Projeto e proprietário atualizados com sucesso!",
        icon: "success",
        confirmButtonText: "OK",
      });

      handleClick();

    } catch (err) {
      console.error('❌ Erro ao atualizar projeto:', err);
      Swal.fire({
        title: "Erro!",
        text: err.message || "Ocorreu um erro ao atualizar o projeto.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRemoveArea = (areaId) => {
    setAreas(prev => prev.filter(area => area.id !== areaId));
  };

  const handleFileInput = (fieldName, event, onChange) => {
    const file = event.target?.files?.[0];

    if (!file) {
      return;
    }

    setSelectedFiles((prev) => ({
      ...prev,
      [fieldName]: file,
    }));

    if (onChange) {
      onChange(file);
    }
  };

  const handleClick = async () => {
    try {
      dispatch(appStatus("Projetos"));
      navigate("/welcome", { replace: true });
    } catch (err) {
      console.error("Erro ao mudar de página:", err);
    }
  };

  const cardValueToSdgKey = Object.fromEntries(
    Object.entries(sdgToCardValueMap).map(([sdgKey, cardValue]) => [
      cardValue,
      sdgKey,
    ])
  );

  return (
    <MainContainer>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <ProfileContainerInfo>
          <Title>Informações Cadastrais</Title>
          <FormContainer>
            <LeftColumn>
              <Row>
                <Label>
                  Qual o nome (fantasia) da sua terra, fazenda ou reserva?
                </Label>
                <ShowInput
                  type="text"
                  id="title"
                  {...register("title")}
                  placeholder="Ex: Fazenda Santa Júlia"
                />
                <ErrorForm message={errors.title?.message} />
              </Row>

              <Row>
                <Label>Qual o endereço da propriedade?</Label>
                <ShowInput type="text" id="address" {...register("address")} />
                <ErrorForm message={errors.address?.message} />
              </Row>

              <Row>
                <Label>Possui Unidade de Conservação (UC) no imóvel?</Label>
                <StyledSelect
                  id="conservation_unit"
                  {...register("conservation_unit")}
                >
                  <option value="" disabled>
                    Selecione uma opção
                  </option>
                  <option value="Privada">Privada</option>
                  <option value="Pública">Pública</option>
                  <option value="Não possui">Não possui</option>
                </StyledSelect>
                <ErrorForm message={errors.conservation_unit?.message} />
              </Row>

              <Row>
                <Label>Possui déficit de reserva legal?</Label>
                {project && (
                  <Controller
                    name="legal_reserve_deficit"
                    control={control}
                    defaultValue={project.legal_reserve_deficit !== null ? String(project.legal_reserve_deficit) : ""}
                    render={({ field }) => (
                      <StyledSelect {...field}>
                        <option value="" disabled>
                          Selecione uma opção
                        </option>
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                      </StyledSelect>
                    )}
                  />
                )}
                <ErrorForm message={errors.legal_reserve_deficit?.message} />
              </Row>

              <Row>
                <Label>
                  Possui dívida federal pelo não pagamento de tributos?
                </Label>
                <StyledSelect
                  id="has_federal_debt"
                  {...register("has_federal_debt")}
                >
                  <option value="" disabled>
                    Selecione uma opção
                  </option>
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </StyledSelect>
                <ErrorForm message={errors.has_federal_debt?.message} />
              </Row>
            </LeftColumn>

            <RightColumn>
              <Row>
                <Label>Proprietário da Área</Label>
                <ShowInput
                  type="text"
                  id="project_owner_name"
                  {...register("project_owner.name")}
                  placeholder="Ex: João da Silva"
                  disabled={existingUserData}

                />
                <ErrorForm message={errors.project_owner?.name?.message} />
              </Row>

              <Row>
                <Label>Email do proprietário</Label>
                <StyledSelect
                  id="project_owner_email"
                  {...register("project_owner.email", {
                    onChange: (e) => applyPropOwner(e.target.value),
                  })}
                  disabled={emailCheckInProgress}
                >
                  <option value="">Selecione um usuário</option>
                  {ownerEmailOptions.map((user) => (
                    <option key={user.id} value={user.email}>
                      {(user.full_name || user.name || "Sem nome") + " — " + user.email}
                    </option>
                  ))}
                </StyledSelect>
                {propUsers.length === 0 && (
                  <small style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>
                    Nenhum usuário do tipo PROP encontrado no sistema.
                  </small>
                )}
                <ErrorForm message={errors.project_owner?.email?.message} />
              </Row>

              <Row>
                <Label>Telefone do proprietário</Label>
                <ShowInput
                  type="text"
                  id="project_owner_phone"
                  {...registerWithMask("project_owner.phone", "(99) 99999-9999")}
                  placeholder="(11) 99999-9999"
                  disabled={existingUserData}

                />
                <ErrorForm message={errors.project_owner?.phone?.message} />
              </Row>

              <Row>
                <Label>Qual o tipo de titular (pessoa) do imóvel?</Label>
                <Controller
                  name="project_owner.person_type"
                  control={control}
                  render={({ field }) => {

                    return (
                      <StyledSelect
                        {...field}
                        id="person_type" // Adicionar ID para poder acessar via DOM
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          handleEntityChange(e);
                        }}
                        disabled={existingUserData}

                      >
                        <option value="Física">Física</option>
                        <option value="Jurídica">Jurídica</option>
                      </StyledSelect>
                    );
                  }}
                />
                <ErrorForm message={errors.project_owner?.person_type?.message} />
              </Row>

              <Row>
                <Label>{isCpf ? "CPF" : "CNPJ"} do proprietário</Label>
                {isCpf ? (
                  <ShowInput
                    type="text"
                    id="cpf" // ID explícito
                    {...registerWithMask(
                      "project_owner.cpf",
                      "999.999.999-99"
                    )}
                    placeholder="Digite o CPF"
                    disabled={existingUserData}

                  />
                ) : (
                  <ShowInput
                    type="text"
                    id="cnpj" // ID explícito
                    {...registerWithMask(
                      "project_owner.cnpj",
                      "99.999.999/9999-99"
                    )}
                    placeholder="Digite o CNPJ"
                    disabled={existingUserData}

                  />
                )}
                <ErrorForm
                  message={
                    isCpf
                      ? errors.project_owner?.cpf?.message
                      : errors.project_owner?.cnpj?.message
                  }
                />
              </Row>
            </RightColumn>

            {isLoadingSdgs ? (
              <SmallText>Carregando ODS...</SmallText>
            ) : (
              <CardCheckbox
                initialSelection={selectedCards}
                onSelectionChange={handleCardSelection}
              />
            )}

            <Row>
              <Label>Imagem Representativa do Projeto</Label>

              {project?.project_image && (
                <ArquivoAtual>
                  Arquivo atual:{" "}
                  {typeof project.project_image === "string"
                    ? project.project_image.split("/").pop()
                    : "Arquivo carregado"}
                </ArquivoAtual>
              )}
              {selectedFiles?.project_image && (
                <ArquivoEscolhido>
                  Arquivo selecionado:{" "}
                  {selectedFiles.project_image.name}
                </ArquivoEscolhido>
              )}
              <Controller
                name="project_image"
                control={control}
                render={({ field }) => (
                  <>
                    <FileInputWrapper>
                      <FileInputButton htmlFor="file-input-project-image">
                        Selecionar Arquivo
                      </FileInputButton>

                      <HiddenFileInput
                        id="file-input-project-image"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileInput("project_image", e, field.onChange)}
                      />
                    </FileInputWrapper>
                  </>
                )}
              />
            </Row>

            <Label>
              Existem ações tomadas pelo proprietário para garantir a
              preservação das florestas existentes no imóvel?
            </Label>
            <Span>
              Descrever abaixo quais são essas ações e a data em que foram
              realizadas.
            </Span>
            <Span>
              Estas ações podem ser in loco, tal como cercamento ou aceiro, ou
              pode ser uma ação legal, tal como averbação da reserva legal na
              matrícula ou criação de uma RPPN.
            </Span>
            <p />
            <TextArea
              type="text"
              id="owner_actions_to_preserve_forest"
              {...register("owner_actions_to_preserve_forest")}
            />
            <ErrorForm
              message={errors.owner_actions_to_preserve_forest?.message}
            />
          </FormContainer>
        </ProfileContainerInfo>

        <ButtonContainer>
          <StyledAddArea type="button" onClick={handleAddArea}>
            Adicionar área
          </StyledAddArea>
        </ButtonContainer>

        {areas.map((area) => (
          <ProfileContainerInfo key={area.id}>
            <Title>Informações da área {area.number}</Title>
            <CreateArea
              areaNumber={area.number}
              onAreaChange={(areaId, areaData) =>
                handleAreaSave(areaId || area.id, areaData)
              }
              onRemove={() => handleRemoveArea(area.id)}
              initialData={area.data}
              isEdit={area.isFromDatabase}
              projectId={project?.id}
            />
          </ProfileContainerInfo>
        ))}

        <ButtonContainer>
          <WarningDeleteModal
            text={"Deletar Projeto"}
            path={"projects"}
            id={project?.id}
          />
          <StyledButtonSalvar
            type="button"
            onClick={handleSubmit(onSubmit)}
            disabled={isSubmitting || emailCheckInProgress}
            style={{ background: 'var(--accent)' }}
          >
            {isSubmitting ? "Salvando..." :
              emailCheckInProgress ? "Verificando email..." : "Salvar"}
          </StyledButtonSalvar>

          <StyledButtonVoltar type="button" onClick={handleClick} style={{ background: 'var(--info)' }}>
            Voltar
          </StyledButtonVoltar>
        </ButtonContainer>
      </motion.div>
    </MainContainer>
  );
};

export default EditProject;